<template>
    <div v-if="hasPermission('metabase.view')">
        <page-title title="Dashboard" icon="pe-7s-display2"></page-title>
        <b-row v-if="isLoading">
            <b-col>
                <font-awesome-icon icon="spinner" spin/>
            </b-col>
        </b-row>
        <b-row v-else>
            <b-col>
                <metabase identifier="dashboard" :parameters="{location_id: locationId}"></metabase>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import PageTitle from "@/components/PageTitle.vue"
import Metabase from "@/components/Metabase.vue"

export default {
    name: "Dashboard",
    components: {PageTitle, Metabase},

    data() {
        return {
            isLoading: true,
            locationId: null,
        }
    },

    mounted() {
        if (this.$store.state.permissions['canmanagealllocations']) {
            this.isLoading = false
        }
        else {
            this.$store.getters.getLocationsForUser
                .then(() => {
                    this.locationId = this.$store.state.locationsForUser[0].id
                    this.isLoading = false
                })
        }
    }
}
</script>

<style scoped>

</style>
